import type { HlsVideoElement } from "hls-video-element";
import HlsVideo from "hls-video-element/react";
import { t } from "@/i18n-js/instance";

interface PlayerProps {
  captionsUrl?: string;
  className?: string;
  contentType?: string;
  isHls?: boolean;
  onEnded?: () => void;
  poster?: string;
  preload?: "none" | "metadata" | "auto";
  src: string;
  videoRef: React.RefObject<HlsVideoElement>;
}

export const Player = ({
  className,
  src,
  contentType,
  captionsUrl,
  preload = "none",
  poster,
  isHls = false,
  onEnded,
  videoRef,
}: PlayerProps) => {
  if (isHls) {
    return (
      <HlsVideo
        className={className}
        slot="media"
        src={src}
        poster={poster}
        preload={preload}
        onEnded={onEnded}
        onContextMenu={e => e.preventDefault()}
        ref={videoRef}
      >
        {captionsUrl && (
          <track
            kind="captions"
            label={t("default")}
            src={captionsUrl}
            srcLang="en"
            default
          />
        )}
      </HlsVideo>
    );
  }

  return (
    <video
      className={className}
      slot="media"
      poster={poster}
      preload={preload}
      onEnded={onEnded}
      onContextMenu={e => e.preventDefault()}
      ref={videoRef}
    >
      <source src={src} type={contentType} />
      {captionsUrl && (
        <track
          kind="captions"
          label={t("default")}
          src={captionsUrl}
          srcLang="en"
          default
        />
      )}
    </video>
  );
};
